import { render, staticRenderFns } from "./ClientCabinHeader.vue?vue&type=template&id=3c63d1ce&scoped=true&"
import script from "./ClientCabinHeader.vue?vue&type=script&lang=ts&"
export * from "./ClientCabinHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCabinHeader.vue?vue&type=style&index=0&id=3c63d1ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63d1ce",
  null
  
)

export default component.exports